export const ImportantDataAlertTexts = {
  subtitle: 'Укажите реальные данные о работе и\u00A0доходе — так шанс одобрения выше',
};
